import axios from "axios";

const baseURL = process.env.REACT_APP_API_END_POINT ? process.env.REACT_APP_API_END_POINT : "https://api.ygbversebeta.com/";

// const baseURL = process.env.REACT_APP_API_END_POINT ? process.env.REACT_APP_API_END_POINT : "http://54.148.162.234:3000/";

// const baseURL = process.env.REACT_APP_API_END_POINT ? process.env.REACT_APP_API_END_POINT : "http://54.148.162.234:3300/";


export const axiosObj = axios.create({
  baseURL,
});
